const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');
// @ constants
const { DATE_FILTER_NONE } = require('constants/index');

class LoanSettlementsFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilter } = props;
        const immDate = immFilter.get('date');

        this.state = {
            dateSelected: immDate.get('selected'),
            dateFrom: immDate.get('from'),
            dateTo: immDate.get('to')
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleFormSubmit(event) {
        event.preventDefault();

        const { onSetFilters, onCloseClick } = this.props;
        const { dateFrom, dateTo, dateSelected } = this.state;

        onSetFilters({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            isActive: dateSelected !== DATE_FILTER_NONE && !!dateFrom && !!dateTo
        });

        onCloseClick();
    }

    render() {
        const { immFilter, onCloseClick } = this.props;
        const modalContent = (
            <article className="loan-settlements-filter">
                <section>
                    <fieldset>
                        <DateFilter
                            immFilter={immFilter.get('date')}
                            last={true}
                            onChangeMin={this.handleChangeDateMin}
                            onChangeMax={this.handleChangeDateMax}
                            onChangeSelected={this.handleChangeDateSelected}
                            showFortnightly={false}
                        />
                    </fieldset>
                </section>
            </article>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={true}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="common-apply"
                secondaryButtonText="common-cancel"
                title="loanSettlementsFilters-loanSettlementsFilters_title"
                type="filter"
            />
        );
    }
}

LoanSettlementsFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onSetFilters: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired
};

module.exports = LoanSettlementsFilter;
